import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NewsletterModal } from './NewsletterModal';
import timAutreyImage from '../images/tim_autrey.jpeg';
import './Sidebar.css';

export function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [newsletterOpen, setNewsletterOpen] = useState(false);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
      onClose();
    }
  };

  const openNewsletter = () => {
    setNewsletterOpen(true);
  };

  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`sidebar-overlay ${isOpen ? 'sidebar-overlay--visible' : ''}`}
        onClick={onClose}
      />

      <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
        {/* Mobile close button */}
        <button className="sidebar__close" onClick={onClose} aria-label="Close menu">
          ×
        </button>

        {/* Logo & Title */}
        <div className="sidebar__header">
          <Link to="/" onClick={onClose}>
            <img
              src={timAutreyImage}
              alt="Tim Autrey"
              className="sidebar__avatar"
            />
          </Link>
          <h1 className="sidebar__title">TIM'S BLOG</h1>
        </div>

        {/* Home */}
        <div className="sidebar__section">
          <Link to="/" className="sidebar__home-link" onClick={onClose}>Home</Link>
        </div>

        {/* Search */}
        <div className="sidebar__section">
          <form onSubmit={handleSearch} className="sidebar__search">
            <input
              type="text"
              placeholder="Search posts..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type="submit" className="btn btn-dark sidebar__search-btn" aria-label="Search">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
            </button>
          </form>
        </div>

        {/* Subscribe */}
        <div className="sidebar__section">
          <h3 className="sidebar__heading">Subscribe</h3>
          <button
            type="button"
            className="btn btn-primary sidebar__subscribe-btn"
            onClick={openNewsletter}
          >
            Sign Up for PRINCIPLES Newsletter
          </button>
          <a
            href="https://ppiweb.io/terms_and_conditions"
            className="sidebar__privacy-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Email Terms & Conditions
          </a>
        </div>

        {/* Learn */}
        <div className="sidebar__section">
          <h3 className="sidebar__heading">Learn</h3>
          <ul className="sidebar__links">
            <li>
              <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">
                Industries We Serve
              </a>
            </li>
            <li>
              <a href="https://ppiweb.io/infographics_downloads" target="_blank" rel="noopener noreferrer">
                Resources & Downloads
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@ppiweb" target="_blank" rel="noopener noreferrer">
                PPI YouTube Channel
              </a>
            </li>
          </ul>
        </div>

        {/* Connect */}
        <div className="sidebar__section">
          <h3 className="sidebar__heading">Connect</h3>
          <ul className="sidebar__links">
            <li>
              <a href="https://www.linkedin.com/company/ppi-global" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            </li>
            <li>
              <a href="https://ppiweb.io/ppi_contact_us" target="_blank" rel="noopener noreferrer">
                Contact
              </a>
            </li>
            <li>
              <a href="https://api.leadconnectorhq.com/widget/bookings/bobcat" target="_blank" rel="noopener noreferrer">
                Schedule a Call
              </a>
            </li>
          </ul>
        </div>

        {/* About */}
        <div className="sidebar__section">
          <h3 className="sidebar__heading">About</h3>
          <ul className="sidebar__links">
            <li>
              <a href="https://ppiweb.io/about_ppi" target="_blank" rel="noopener noreferrer">
                About PPI
              </a>
            </li>
            <li>
              <a href="https://ppiweb.io/ppi_manifesto" target="_blank" rel="noopener noreferrer">
                Our Manifesto
              </a>
            </li>
            <li>
              <a href="https://ppiweb.io/our_team" target="_blank" rel="noopener noreferrer">
                Our Team
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/watch?v=7Jotm_imuIY&t=333s" target="_blank" rel="noopener noreferrer">
                PPI Documentary
              </a>
            </li>
          </ul>
        </div>

        {/* Admin - hidden from public, access via /admin URL directly */}
        {/* <div className="sidebar__section sidebar__admin">
          <Link to="/admin" onClick={onClose}>Admin</Link>
        </div> */}
      </aside>

      {/* Newsletter Modal */}
      <NewsletterModal isOpen={newsletterOpen} onClose={() => setNewsletterOpen(false)} />
    </>
  );
}
